<template>
  <el-select
    v-model="selectValue"
    filterable
    clearable
    size="small"
    :disabled="disabled"
    :style="{width: width}"
    :multiple="selectType"
    collapse-tags
    placeholder="请选择"
    @change="toParent">
    <el-option
      v-for="item in options"
      :key="item.keyValue"
      :label="item.keyName"
      :value="item.keyValue">
    </el-option>
  </el-select>
</template>

<script>
import { querySysMediaParam } from '@/api/common'
import { queryCommonConfParam } from '@/api/oms'
import {getAllRole, getAllPosition} from '@/api/roleManage'
export default {
  props: {
    orgId: {
      type: String,
      required: false,
      default: ''
    },
    checkedValue: {
      type: String,
      required: false,
      default: ''
    },
    propertyType: {
      type: String,
      required: true,
      default: 'PROJECT_LEVEL'
    },
    selectType: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: ''
    },
    allSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    value: null
  },
  data () {
    return {
      options: [],
      selectValue: this.value
    }
  },
  watch: {
    value (val) {
      this.selectValue = val + ''
    }
  },
  created () {
    this.searchData()
  },
  methods: {
    toParent () {
      if (this.allSelect) {
        this.options.push({keyValue: -1, keyName: '全部'})
      }
      if (this.selectValue === undefined) {
        this.selectValue = ''
      }
      this.$emit('data', this.selectValue, this.propertyType)
    },
    searchData () {
      let commonModel = {
        filter: ''
      }
      if (this.propertyType === null || this.propertyType === undefined) {
        return
      }
      commonModel.filter = 'type=' + this.propertyType + ';'
      if (this.propertyType === 'PROJECT_STATE') {
        this.options = [
          {keyValue: 1, keyName: '可售'},
          {keyValue: 2, keyName: '维护'},
          {keyValue: 3, keyName: '预拆除'},
          {keyValue: 4, keyName: '拆除'},
          {keyValue: 5, keyName: '已到期'}]
      } else if (this.propertyType === 'PROJECT_STATUS') {
        this.options = [
          {keyValue: 1, keyName: '新增数据'},
          {keyValue: 2, keyName: '待审核'},
          {keyValue: 3, keyName: '审核通过'},
          {keyValue: 4, keyName: '审核未通过'}]
      } else if (this.propertyType === 'ELEVATOR_POSITION') {
        this.options = [
          {keyValue: '2', keyName: '大堂'},
          {keyValue: '3', keyName: '独立大堂'},
          {keyValue: '4', keyName: 'B1大堂'},
          {keyValue: '5', keyName: 'B2大堂'},
          {keyValue: '6', keyName: 'B3大堂'},
          {keyValue: '7', keyName: 'B4大堂'}]
      } else if (this.propertyType === 'FLOOR_POSITION') {
        this.options = [
          {keyValue: 2, keyName: '一层梯外'},
          {keyValue: 3, keyName: '负一层梯外'},
          {keyValue: 4, keyName: '负二层梯外'},
          {keyValue: 5, keyName: '负三层梯外'},
          {keyValue: 6, keyName: '其他楼层'}]
      } else if (this.propertyType === 'USER_ROLE') {
        getAllRole().then(res => {
          let result = res.data.data
          if (result.length < 1) {
            this.options = []
          } else {
            result.forEach(m => {
              this.options.push({
                keyValue: m.roleId,
                keyName: m.roleName
              })
            })
          }
        }).catch(() => {
          this.options = []
        })
      } else if (this.propertyType === 'USER_POSITION') {
        getAllPosition().then(res => {
          let result = res.data.data
          this.options = []
          if (result) {
            result.forEach(m => {
              this.options.push({
                keyValue: m.positionId,
                keyName: m.positionName
              })
            })
          }
        }).catch(() => {
          this.options = []
        })
      } else if (this.propertyType === 'PROJECT_TYPE' || this.propertyType === 'PROJECT_LEVEL' || this.propertyType === 'MEDIA_TYPE' || this.propertyType === 'MEDIA_SIZE') {
        queryCommonConfParam(this.propertyType).then(result => {
          let datas = result.data.data
          datas.forEach(m => {
            this.options.push({keyValue: m.optionValue, keyName: m.optionName})
          })
        }).catch((e) => {
        })
      } else {
        querySysMediaParam(commonModel).then(result => {
          this.options = result.data.data.aaData
        }).catch((e) => {
        })
      }
      setTimeout(() => this.toParent(), 1000)
    },
    clearValue () {
      this.selectValue = ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dropdowns/index.vue